import { render, staticRenderFns } from "./filtri.vue?vue&type=template&id=4dc68366"
import script from "./filtri.vue?vue&type=script&lang=js"
export * from "./filtri.vue?vue&type=script&lang=js"
import style0 from "./filtri.vue?vue&type=style&index=0&id=4dc68366&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports